import {Fragment} from 'react';

const Body: (props: any) => JSX.Element = (props: any) => {

    const {children, header, footer} = props;

    return (
        <Fragment>
            {children &&
                <div className="flex flex-col h-full justify-between">
                    {header &&
                        <div className="flex flex-row justify-center items-center min-h-[100px] header">
                            {header}
                        </div>
                    }
                    <div className="flex flex-col justify-center items-center p-5 md:p-0">
                        <div className="w-[100%] max-w-[1200px] mx-auto my-10">
                            {children}
                        </div>
                    </div>
                    {footer &&
                        <div className="flex flex-row justify-center items-center py-4 footer">
                            {footer}
                        </div>
                    }
                </div>
            }
        </Fragment>
    );
}

export default Body;
